import { Component, ChangeDetectionStrategy } from "@angular/core";
import { FooterComponent } from "../../shared/footer/footer.component";
import { LoginComponent } from "../login/login.component";
import { SharedModule } from "../../shared/shared.module";

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  imports: [SharedModule, FooterComponent, LoginComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ["./home.component.scss"],
})
export class HomeComponent {}
